<div class="h-full">
  <div class="launch-container justify-content-center gap-4">
    @if(homePageService.focusedView$() === 'none' ||
    homePageService.focusedView$() === 'auctions'){
    <div class="box" (click)="selectView('auctions')">
        <span class=" title">
          Aukcje produktowe <span class="red">{{ coreList().auctionsCount }} </span>
        </span>
        <div class="img-container">

          <img
             src="assets/images/new/wersja2 (a).png"
             alt="Logo"
           />
        </div>
      <!-- <div class="name-container">
        <p class="white title">
          Aukcje produktowe <span class="red">{{ coreList().auctionsCount }} </span>
        </p>
        <app-info-button
          [customClass]="'home-page'"
          [dialogContent]="
            'Ilość aukcji, które są aktualnie dostępne na platformie.'
          "
        />
      </div>
      <div class="image-container">
        <img
          src="assets/images/auctions.png"
          alt="Logo"
          style="width: 100%; object-fit: contain"
        />
      </div> -->
    </div>
    } @if(homePageService.focusedView$() === 'none' ||
    homePageService.focusedView$() === 'codes'){
    <div class="box" (click)="selectView('codes')">
        <span class=" title">
          Kody rabatowe <span class="red">{{ coreList().onReelCount }} </span>
        </span>
        <div class="img-container">

          <img
             src="assets/images/new/wersja1 (b).png"
             alt="Logo"
           />
        </div>
      <!-- <div class="name-container">
        <p class="white title">
          Kody rabatowe <span class="red">{{ coreList().onReelCount }} </span>
        </p>
        <app-info-button
          [customClass]="'home-page'"
          [dialogContent]="'Ilość kodów rabatowych, które możesz wykorzystać.'"
        />
      </div>
      <div class="image-container">
        <img
          src="assets/images/discountCodes.png"
          alt="Logo"
          style="width: 100%; object-fit: contain"
        />
      </div> -->
    </div>
    } 
  </div>
</div>
